import EditClaimant from "./EditClaimant";

export default EditClaimant;